// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3V-Wz","disabled":"Button_disabled__2Fze_","withIcon":"Button_withIcon__EjVJj","modText":"Button_modText__1zl4Z"};